import { create } from "zustand"

export interface ToastData {
  /** Bumped on each show so the same message re-triggers the animation/timer. */
  id: number
  title: string
  subtitle?: string
}

interface ToastState {
  toast: ToastData | null
  show: (toast: Omit<ToastData, "id">) => void
  hide: () => void
}

let nextId = 1

export const useToastStore = create<ToastState>((set) => ({
  toast: null,
  show: (toast) => set({ toast: { ...toast, id: nextId++ } }),
  hide: () => set({ toast: null }),
}))

/** Show the global error toast from anywhere (including non-React code). */
export function showErrorToast(title: string, subtitle?: string) {
  useToastStore.getState().show({ title, subtitle })
}
